<template>
    <div class="shouyeBox" >
      <headTotal></headTotal>
      <div class="shouyeCon">
        <div class="shouyeCon1" style="width:100%;display:flex;">
          <el-carousel height="400px" style="width:75%;">
            <el-carousel-item v-for="item in list" >
              <img :src="$baseUrl+item.imgs"  style="width:100%;height:100%;object-fit:cover">
            </el-carousel-item>
          </el-carousel>
          <div class="swiRight" style="width:25%;display:flex;flex-direction:column;">
            <div class="banjiaBox" style="width:100%;height:100%;display:flex;box-sizing:border-box;margin-left:5px;justify-content:space-between;flex-direction:column;">
                <img src="@/assets/vip.jpg" style="width:100%;display:block;">
              <img src="@/assets/qq.jpg" style="width:100%;display:block;" @click="toKf">

            </div>
          </div>
        </div>
        <div class="zuixin">
          <div class="zuixinTitle">
            <span>最新电脑vr游戏</span>
          </div>
          <div class="gameList" style="background-color: #fff;width:100%;margin:auto;display: flex; flex-wrap: wrap;">

            <div @click="selectGame(game)" class="game" v-for="game in gameList" :key="game.id" style="position: relative;cursor:pointer;width: 24%;margin: 20px 0.5%;text-align: left">
              <div class="gameImgBox" style="width:100%;height:200px;overflow: hidden;">
                <img :src="$baseUrl+(game.imgs?game.imgs.split(',')[0]:'')" alt=""  class="gameImg">

              </div>
              <span style="text-align: left;">{{game.name}}</span>
              <div style="position: absolute;top: 5px;right: 5px;display: flex;font-size: 12px;">
            <span v-for="tag in game.tags" :key="tag.name" style="color:deepskyblue;background-color: rgba(100,100,100,0.5);margin-right: 5px;padding: 1px;">
              {{tag.name}}
            </span>
              </div>

            </div>
          </div>
        </div>
        <div class="zuixin">
          <div class="zuixinTitle">
            <span>最新Meta Quest游戏</span>
          </div>
          <div class="gameList" style="background-color: #fff;width:100%;margin:auto;display: flex; flex-wrap: wrap;">

            <div @click="selectGame(game)" class="game" v-for="game in gameList1" :key="game.id" style="position: relative;cursor:pointer;width: 24%;margin: 20px 0.5%;text-align: left">
              <div class="gameImgBox" style="width:100%;height:200px;overflow: hidden;">
                <img :src="$baseUrl+(game.imgs?game.imgs.split(',')[0]:'')" alt=""  class="gameImg">

              </div>
              <span style="text-align: left;">{{game.name}}</span>
              <div style="position: absolute;top: 5px;right: 5px;display: flex;font-size: 12px;">
            <span v-for="tag in game.tags" :key="tag.name" style="color:deepskyblue;background-color: rgba(100,100,100,0.5);margin-right: 5px;padding: 1px;">
              {{tag.name}}
            </span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>

  import headTotal from "@/components/qt/headTotal.vue";
  import {getGameList, getGameListByKeyWord} from "@/api/qt/common";
  export default {
    name:"shouye",
    components: {headTotal},
    data(){
      return {
        list:[],
        gameList:[],
        gameList1:[],
      }
    },
    created(){
      this.getList();
      this.init();
      this.bindAdminMy()
      if(!localStorage.getItem('isShowGg')){
        this.$alert('游戏均为破解版，免费玩', {
          confirmButtonText: '确定',
          // callback: action => {
          //   // this.$message({
          //   //   type: 'info',
          //   //   message: `action: ${ action }`
          //   // });
          // }
        });
        localStorage.setItem("isShowGg",1)
      }
    },
    methods:{
      bindAdminMy(){
        const params = new URLSearchParams(window.location.search);
        let adminId = params.get('adminId');
        if(adminId){
          localStorage.setItem("adminId",adminId);
        }

      },
      init(){
        let loading=this.$loading({
          mask:true,
        })

        getGameList('7',1).then(res=>{
          let data=res.data.data.data;
          this.gameList=data.slice(0,12);
          loading.close()
        })
        getGameList('8',1).then(res=>{
          let data=res.data.data.data;
          this.gameList1=data.slice(0,12);
          loading.close()
        })
      },
      toKf(){
          window.location.href="tencent://message/?uin=1832111057&Site=八角游戏&Menu=yes"
      },
      getList(){
        getGameListByKeyWord('',1).then((res)=>{
          let data=res.data.data.data
          this.list=data.slice(0,4);

        })
      },
      selectGame(row){

        let str=row.id+'-'+row.cls_ids
        window.open('/#detail?info='+ str,"_blank");
      }
    }
  }
</script>
<style scoped>
.shouyeBox{
  width:90%;
  margin: auto;
  min-width: 1400px;
  background-color: #fff;
  min-height: 100vh;
  padding-bottom: 30px;
  position: relative;

}
.shouyeCon{
  width: 80%;
  margin-left: 10%;
  box-sizing: border-box;
  margin-top:10px;
}
.zuixin{
  width: 100%;
  box-sizing: border-box;
  margin-top:10px;
}
.zuixinTitle{
  line-height:50px;
  font-size:20px;
  text-align: center;
}
.zuixinTitle > span{
  color:#fff;
  border-radius:5px;

  padding:8px 40px;
  background-color:#2c3e50;
}
</style>
